"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./AlertBox.css");

var _Elements = require("../Elements");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Alert box
    ---
    An alert box with a simple true false option
*/
// Our main component
var AlertBox = function AlertBox(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "alertBoxWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "alertBox scale_in"
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.message), props.accept_text && props.cancel_text && /*#__PURE__*/_react["default"].createElement("div", {
    className: "alertBoxButtons"
  }, props.accept_text && /*#__PURE__*/_react["default"].createElement(_Elements.Button, {
    bgColor: ['success'],
    text: props.accept_text,
    size: "S",
    txtColor: "white",
    type: "main",
    onClick: function onClick() {
      return props.onAccept(true);
    }
  }), props.cancel_text && /*#__PURE__*/_react["default"].createElement(_Elements.Button, {
    bgColor: ['error'],
    text: props.cancel_text,
    size: "S",
    txtColor: "white",
    type: "main",
    onClick: function onClick() {
      return props.onDecline(false);
    }
  })), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    className: "cancel",
    name: "Close",
    onClick: function onClick() {
      return props.onClick(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "alertBoxBg",
    onClick: function onClick() {
      return props.onDecline(false);
    }
  }));
};

var _default = AlertBox;
exports["default"] = _default;